import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/draft2digital': {
    width: 480,
    height: 512,
    paths: [
      {
        d: 'M369.9 425.4V371L417 398.2 369.9 425.4zM82.4 380.6C107.9 353.3 180.1 275.9 233.3 210.6 268.4 167.5 273.6 128.2 261.7 97.9 254.3 79.1 244.2 67.7 237.4 62.2 282.7 64.3 305.4 85.6 319.6 100.5 319.6 100.5 362 148.7 325.4 213.8 288.4 279.7 214.5 361.3 196.9 380.5H82.4zM134.2 161.4C134.2 173.8 124.2 183.8 111.8 183.8 99.4 183.8 89.4 173.8 89.4 161.4 89.4 149 99.4 139 111.8 139 124.2 139 134.2 149.1 134.2 161.4M336 315.9V380.6H244.7C275.5 345.6 326.5 284.7 356.5 231.3 391.7 168.7 372.6 107.9 343.7 78 339.3 73.4 281.5 15.1 177.7 36.8 118.6 49.2 88.3 80.2 73.4 104.1 60.3 125 56.4 143.9 55.2 151.8 49.7 184.8 74.6 218.9 111.9 218.9 143.6 218.9 169.2 193.2 169.2 161.5 169.2 134.4 149.5 109.4 121.2 104.7 123 97.4 138.9 83.6 147.5 80 188.6 62.7 225.5 85.2 230.8 113.5 239.1 157.8 193.7 203.9 161.1 241.1 84.5 328.1 18.3 396.8 0 415.9L336 415.8V480L480 398.1 336 315.9z'
      }
    ]
  }
})
